//#region Dependencies
import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import NavBar from "./Components/NavBar";
import Authentication from "./Pages/Authentication";
import Router from "./Pages/Router";
//#endregion

import GlobalStyle, { darkTheme, lightTheme } from "./styles/global";

export interface UserPermissions {
  ORI: {
    Admin: boolean;
    Researcher: boolean;
  };
  OrgAdmin: Array<string>;
  OrgClinical: Array<string>;
  OrgDeveloper: Array<string>;
}

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [sessionActive, setSessionActive] = useState(true);
  const [userPermissions, setUserPermissions] = useState<UserPermissions>({
    ORI: {
      Admin: false,
      Researcher: false,
    },
    OrgAdmin: [],
    OrgClinical: [],
    OrgDeveloper: [],
  });

  const checkSessionActive = () => {
    fetch("/api/v1/account/auth/session/isValid", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success === true) {
          setSessionActive(
            data.valid === "true" || data.valid === true ? true : false
          );
        } else {
          setSessionActive(false);
        }
      });
  };

  useEffect(() => {
    checkSessionActive();

    const interval = setInterval(() => {
      if (sessionActive === true) {
        checkSessionActive();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [sessionActive]);

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <>
        <GlobalStyle />
        {sessionActive ? (
          <BrowserRouter>
            <NavBar
              userPermissions={userPermissions}
              setDarkMode={setDarkMode}
              setUserPermissions={setUserPermissions}
            />
            <Router userPermissions={userPermissions} />
          </BrowserRouter>
        ) : (
          <Authentication setSessionActive={setSessionActive} />
        )}
      </>
    </ThemeProvider>
  );
}

export default App;
